import { servicios } from "../properties";
import { callService, goTo } from "../tools";
import { database } from "../app-database";
import axios from 'axios';

const aplication = "application/json";
const mensaje1 = "Tuvimos un error";
const mensaje = "Hubo un error al validar las preguntas. Favor de intentar más tarde.";
const mensaje2 = "Hubo un error. Inténtelo más tarde.";
const mensaje3 = "Hubo un error al mandar el correo. Favor de intentar más tarde.";
const mensaje4 = "Lo sentimos, el correo electrónico proporcionado no está registrado.";
const servicioEnviarCorreo = "olvideContrasena.enviarCorreo";

export const validarEmail = (sParam) => {
	return fetch(servicios.validarEmail, {
		method: "post",
		body: JSON.stringify({
			usuario: sParam,
		})
	});
};

export const validarPass = (uid, mail, password) => {
	console.log('Actualizacion');
	return new Promise(resolve => {
		axios({
			method: 'POST',
			url: servicios.utilerias.actualizaNodoRestablecer,
			headers: {
				'Content-Type': aplication,
				'Access-Control-Allow-Origin': '*',
				"valor": mail,
				"encripta": true
			}
		}).then(responseEmail => {
			axios({
				method: 'POST',
				url: servicios.utilerias.actualizaNodoRestablecer,
				headers: {
					'Content-Type': aplication,
					'Access-Control-Allow-Origin': '*',
					"valor": password,
					"encripta": true
				}
			}).then(responsePass => {
				const encriptar = true;
				resolve(fetch(servicios.validarPass + "?mail=" + responseEmail.data.hash + "&password=" + responsePass.data.hash
					+ "&encriptar=" + encriptar));
			}).catch(error => {
				console.log(error);
			});
		}).catch(error => {
			console.log(error);
		});
	});
};


export const verificarPregunta = (sParam) => {
	return fetch(servicios.verificarPregunta, {
		method: "post",
		body: JSON.stringify({
			p: sParam.p,
			r: sParam.r
		})
	});
};

export const validarCorreo = (correo, dispositivo) => {
	return dispatch => {
		dispatch({ "type": "LOGIN_SET_ERROR", "error": false, "mensaje": "" });
		dispatch({ "type": "LOADER_SHOW" });

		axios({
			method: 'POST',
			url: servicios.utilerias.actualizaNodoRestablecer,
			headers: {
				'Content-Type': aplication,
				'Access-Control-Allow-Origin': '*',
				"valor": correo,
				"encripta": true
			}
		}).then(response => {
			const encriptar = true;
			new callService({
				"service": "login.bienvenido",
				"secure": true,
				"data": { "correo": response.data.hash, "encriptar": encriptar }
			}).execute().then(body => {

				dispatch({ "type": "LOADER_SHOW" });
				if (body.consultarClienteResponse.nombre !== "") {
					localStorage.setItem("UsuarioExisteB", true);

					if (body.consultarClienteResponse.banderaExitoReg !== true) {
						consultaRegistro(dispatch);
					} else {
						dispatch({ "type": "LOADER_HIDE" });
					}

				} else {
					dispatch({ "type": "LOADER_HIDE" });
					localStorage.setItem("UsuarioExisteB", false);
				}

				if (body.hasOwnProperty("error")) {
					dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", "titulo": "Error", "mensaje": mensaje1 });
				} else if (body.hasOwnProperty("consultarClienteResponse")) {
					dispatch({ "type": "LOGIN_SET_SECRETO", "secreto": body.consultarClienteResponse.nombre });
					dispatch({ "type": "LOGIN_SET_CVECLIENTE", "cveCliente": body.consultarClienteResponse.cveClienteUnico });
					dispatch({ "type": "EVENT_LOGIN_INICIARSESION_CORRECTOS", "flujo": "login", "dispositivo": dispositivo });
				} else if (body.hasOwnProperty("uid") && body.hasOwnProperty("estatus")) {
					const url = body.uid + "/" + body.time + "/" + body.estatus;
					dispatch({ "type": "LOADER_SHOW" });
					dispatch({ "type": "LOGIN_RESET_PASO" });
					servicioEnviar(url, correo);
				}
			}).catch(error => {
				console.log("error", error);
				localStorage.setItem("UsuarioExisteB", false);
				dispatch({ "type": "LOGIN_SET_SECRETO", "secreto": "" });
				dispatch({ "type": "LOADER_HIDE" });

				if (error.message.codigoError === "eCl00014") {
					dispatch({
						"type": "LOGIN_SET_ERROR",
						"error": true,
						"mensaje": mensaje4
					});
				}
				else if (error.body.hasOwnProperty("error")) {
					dispatch({
						"type": "LOGIN_SET_ERROR",
						"error": true,
						"mensaje": mensaje4
					});
					dispatch({ "type": "EVENT_LOGIN_INICIARSESION-INCORRECTOS", "flujo": "login", "dispositivo": dispositivo });
				} else {
					dispatch({
						"type": "MODAL_ALERT_MESSAGES_SHOW",
						"titulo": "Error",
						"mensaje": "Hubo un error al obtener el nombre. Favor de intentar más tarde."
					});
				}
			});
		}).catch(error => {
			console.log("ERROR", error);
			return "";
		});

	};
};

const consultaRegistro = (dispatch) => {
	const email = localStorage.getItem("correoG");
	if (localStorage.getItem("UsuarioExisteB") === "true") {
		new callService({
			"service": "registro.incConsultaRegistro",
			"secure": true,
			"data": {
				"correo": email.toLowerCase()
			}
		}).execute().then((respuesta) => {
			console.log("respuesta ingresaCorreo incConsultaRegistro:", respuesta, email);
			if (respuesta.banConcluirReg.toString() === 'false') {

				localStorage.setItem("banConcluirReg", respuesta.banConcluirReg);
				localStorage.setItem("correoInconcluso", email);
				localStorage.setItem("correoModal", email);
				dispatch({ "type": "LOADER_HIDE" });
				goTo("gnp/registro");

			} else {
				dispatch({ "type": "LOADER_HIDE" });
				console.log("registro terminado", this.props.dispositivo, email);
				localStorage.removeItem("banConcluirReg");
				this.props.pasoSiguiente(email, this.props.dispositivo);
			}
		}).catch((error) => {
			dispatch({ "type": "LOADER_HIDE" });
			console.log("Error??", error);
			this.props.pasoSiguiente(email, this.props.dispositivo);
		});
	}
}

const servicioEnviar = (url, correo) => {

	new callService({
		"service": servicioEnviarCorreo,
		"secure": true,
		"data": { correo: correo, url: url, tipo: "migrado" }
	}).execute().then(body => {
		dispatch({ "type": "LOADER_HIDE" });

		if (body.hasOwnProperty("error")) {
			dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", "titulo": "Error", "mensaje": mensaje1 });
		} else {
			if (body.correlationId !== "") {
				$("#modal-revisa-correo").modal("show");
				$("#correo-login").val("");
			} else {
				dispatch({
					"type": "MODAL_ALERT_MESSAGES_SHOW",
					"titulo": "Error",
					"mensaje": mensaje3
				});
			}
		}
	}).catch(error => {

		errorMensaje3();
	});
}

const errorMensaje3 = () => {
	dispatch({ "type": "LOADER_HIDE" });
	dispatch({
		"type": "MODAL_ALERT_MESSAGES_SHOW",
		"titulo": "Error",
		"mensaje": mensaje3
	});
}

export const getNombre = (correo, dispositivo) => {
	return dispatch => {
		dispatch({ "type": "LOGIN_SET_ERROR", "error": false, "mensaje": "" });
		dispatch({ "type": "LOADER_SHOW" });

		new callService({
			"service": "login.nombre",
			"secure": true,
			"data": { "correo": correo }
		}).execute().then(body => {
			dispatch({ "type": "LOADER_HIDE" });

			if (body.hasOwnProperty("error")) {
				dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", "titulo": "Error", "mensaje": mensaje1 });

			} else if (body.hasOwnProperty("name")) {
				dispatch({ "type": "LOGIN_SET_SECRETO", "secreto": body.name });
				dispatch({ "type": "LOGIN_SET_CVECLIENTE", "cveCliente": body.uid });
				dispatch({ "type": "LOGIN_PASO_SIGUIENTE" });
				dispatch({ "type": "EVENT_LOGIN_INICIARSESION_CORRECTOS", "flujo": "login", "dispositivo": dispositivo });

			} else if (body.hasOwnProperty("uid") && body.hasOwnProperty("estatus")) {
				const url = body.uid + "/" + body.time + "/" + body.estatus;
				dispatch({ "type": "LOADER_SHOW" });
				dispatch({ "type": "LOGIN_RESET_PASO" });

				new callService({
					"service": servicioEnviarCorreo,
					"secure": true,
					"data": { correo: correo, url: url, tipo: "migrado" }
				}).execute().then(respuesta => {
					dispatch({ "type": "LOADER_HIDE" });
					enviarCorreo(respuesta);

				}).catch(error => {

					errorMensaje3();

				});
			}
		}).catch(errorN => {
			dispatch({ "type": "LOADER_HIDE" });
			servicioNombre(errorN);

		});
	};
};

const servicioNombre = (error) => {
	if (error.body.hasOwnProperty("error")) {
		dispatch({
			"type": "LOGIN_SET_ERROR",
			"error": true,
			"mensaje": mensaje4
		});
		dispatch({ "type": "EVENT_LOGIN_INICIARSESION-INCORRECTOS", "flujo": "login", "dispositivo": dispositivo });
	} else {
		dispatch({
			"type": "MODAL_ALERT_MESSAGES_SHOW",
			"titulo": "Error",
			"mensaje": "Hubo un error al obtener el nombre. Favor de intentar más tarde."
		});
	}
}

const enviarCorreo = (body) => {
	if (body.hasOwnProperty("error")) {
		dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", "titulo": "Error", "mensaje": mensaje1 });
	} else {
		if (body.correlationId !== "") {
			$("#modal-revisa-correo").modal("show");
			$("#correo-login").val("");
		} else {
			dispatch({
				"type": "MODAL_ALERT_MESSAGES_SHOW",
				"titulo": "Error",
				"mensaje": mensaje3
			});
		}
	}
}

export const cargarPreguntas = (correo) => {
	return dispatch => {
		dispatch({ "type": "LOADER_SHOW" });
		new callService({
			service: "login.obtenerPreguntas",
			"secure": true,
			data: { correo: correo }
		}).execute().then(body => {
			// Catalogo de preguntas secretas
			database.ref("preguntas").on("value", snapshot => {
				const data = snapshot.val();

				dispatch({
					"type": "CARGAR_CATALOGO_PREGUNTAS",
					"catalogoPregunta1": data.pregunta1,
					"catalogoPregunta2": data.pregunta2
				});
			});

			if (body.hasOwnProperty("error")) {
				dispatch({
					"type": "MODAL_ALERT_MESSAGES_SHOW",
					"titulo": "Error",
					"mensaje": mensaje1
				});
			} else {
				localStorage.setItem("clienteUnico", body.uid);
				dispatch({
					"type": "LOGIN_SET_PREGUNTAS",
					"p1": body.p1,
					"p2": body.p2,
				});
				dispatch({
					"type": "LOGIN_SET_UID",
					"uid": body.uid,
				});
			}
			dispatch({ "type": "LOADER_HIDE" });
		}).catch(error => {
			dispatch({ "type": "LOADER_HIDE" });
			dispatch({
				"type": "MODAL_ALERT_MESSAGES_SHOW",
				"titulo": "Error",
				"mensaje": "Hubo un error al obtener las preguntas. Favor de intentar más tarde."
			});
		});
	};
};

export const desbloquearUsuario = (datos) => {
	return dispatch => {
		dispatch({ "type": "LOADER_SHOW" });

		new callService({
			service: "login.validarPreguntas",
			"secure": true,
			data: datos
		}).execute().then(body => {

			if (body.hasOwnProperty("error")) {
				dispatch({ "type": "LOADER_HIDE" });
				dispatch({
					"type": "MODAL_ALERT_MESSAGES_SHOW",
					"titulo": "Error",
					"mensaje": mensaje
				});
			}
			else {

				dispatch({ "type": "LOADER_HIDE" });
				if (body.hasOwnProperty("validacionPreguntasSeguridadResponse") && body.validacionPreguntasSeguridadResponse.return === "SUCCEEDED") {

					const llamaServicio = new callService({ service: "login.desbloqueoMedios", secure: true, data: { "uid": localStorage.getItem("clienteUnico") } }).execute();
					llamaServicio.then(() => {

						dispatch({
							"type": "MODAL_ALERT_MESSAGES_SHOW",
							"titulo": "Cuenta desbloqueada",
							"mensaje": "¡Listo! Tu cuenta ha sido desbloqueada. Ingresa nuevamente para acceder a tu cuenta."
						});
						dispatch({ "type": "LOGIN_RESET_PASO" });
					}).catch((error) => {
						console.log("Error", error);
					});
				}
				else if (body.hasOwnProperty("suspenderCuentaResponse") && body.suspenderCuentaResponse.return === "SUCCEEDED") {

					if (localStorage.getItem("inactividad")) {

						dispatch({
							"type": "MODAL_ALERT_MESSAGES_SHOW",
							"titulo": "Respuestas incorrectas",
							"mensaje": "Tus preguntas secretas no coinciden, selecciona la opción de \"Reestablecer preguntas secretas\""
						});

					} else {
						dispatch({ "type": "LOGIN_SET_EVENT", "evento": "Respuestas Incorrectas - PreguntasUsuarioBloqueado" });
						dispatch({ "type": "LOGIN_PASO_SIGUIENTE" });
					}
				}
				else {
					dispatch({
						"type": "MODAL_ALERT_MESSAGES_SHOW",
						"titulo": "Error",
						"mensaje": mensaje
					});
				}
			}
		}).catch(error => {
			dispatch({ "type": "LOADER_HIDE" });
			dispatch({
				"type": "MODAL_ALERT_MESSAGES_SHOW",
				"titulo": "Error",
				"mensaje": mensaje
			});

		});
	};
};

export const enviarEmail = (correo) => {
	return dispatch => {
		dispatch({ "type": "LOADER_SHOW" });
		new callService({
			service: "olvideContrasena.consultarUsuario",
			"secure": true,
			data: { correo: correo }
		}).execute().then(body => {
			if (body.hasOwnProperty("error")) {
				dispatch({ "type": "LOADER_HIDE" });
				dispatch({
					"type": "MODAL_ALERT_MESSAGES_SHOW",
					"titulo": "Error",
					"mensaje": mensaje1
				});
			}
			else {
				if (body.uid === 0) {
					dispatch({ "type": "LOADER_HIDE" });
					dispatch({
						"type": "MODAL_ALERT_MESSAGES_SHOW",
						"titulo": "Error",
						"mensaje": mensaje2
					});
				}
				else {
					const url = body.uid + "/" + body.time + "/" + body.estatus;
					new callService({
						service: servicioEnviarCorreo,
						"secure": true,
						data: { correo: correo, url: url }
					}).execute().then(respuesta => {
						dispatch({ "type": "LOADER_HIDE" });
						servicioEnviarEmail(respuesta);

					}).catch(error => {

						errorMensaje3();
					});
				}
			}
		}).catch(error => {

			errorMensaje3();


		});
	};
};

const servicioEnviarEmail = (body) => {
	if (body.hasOwnProperty("error")) {
		dispatch({
			"type": "MODAL_ALERT_MESSAGES_SHOW",
			"titulo": "Error",
			"mensaje": mensaje2
		});
	}
	else {

		if (body.hasOwnProperty("correlationId") && body.correlationId !== "") {
			$("#modal-correcto").modal("toggle");
		}
		else {
			dispatch({
				"type": "MODAL_ALERT_MESSAGES_SHOW",
				"titulo": "Error",
				"mensaje": mensaje2
			});
		}
	}
}

export const aceptoContrato = (uid, email, pass) => {

	return fetch(servicios.login.actualizaContrato, {
		headers: {
			"Accept": aplication,
			"Content-Type": aplication
		},
		method: "POST",
		body: JSON.stringify({
			uid: uid,
			email: email,
			pass: pass
		})

	});
};



// WEBPACK FOOTER //
// ./src/gnp-login/services.act.js